// @import dependencies
import React, {Component} from 'react'
import { connect } from 'react-redux'
import { CombinedReducers as IState } from 'app_events/index'
// @end

// @import components
import {BannerModuleLayout} from 'app_components/modules/newsEvents/banner'
// @end

// @import events
// @end

// @import utils
// @end

// @import services
import BannerService from 'app_services/campus/banner/bannerService'
// @end

// @import types
import {IBanner} from 'app_types/campus/banner/bannerTypes'
import { setInterval } from 'timers'
// @end

// @ADD Component types
interface IBannerModuleProps {
  category?: 'student_landing' | 'guest'
}
interface IBannerModuleState {
  banners: Array<IBanner>
  activeIndex: number
}

// @INFO: Connect react storage state
const mapStatesToProps = (state: IState) => {return state}

class BannerModule extends Component<IBannerModuleProps, IBannerModuleState> {

  private intervalCarousel: any = null
  private bannerService: BannerService

  /*===============================================
  =            Estructura de un metodo            =
  ================================================
    // La estructura de un metodo debe ser la siguiente:
    methodName = () => {}
  /*======  End of Estructura de un metodo  =====*/

  constructor(props: IBannerModuleProps) {
    super(props)
    this.state = {
      banners: [],
      activeIndex: 0
    }

    this.bannerService = new BannerService()
  }

  /**
   * Evento que se ejecuta cuando el componente es montado
   */
  componentDidMount = async () => {
    clearInterval(this.intervalCarousel)
    this.fetchBanners()
  }

  /**
   * Evento que se ejecuta cuando el componente es desmontado
   */
  componentWillUnmount = () => {
    clearInterval(this.intervalCarousel)
  }

  /**
   * Evento que se ejecuta cuando el componente es actualizado
   */
  componentDidUpdate = () => {}

  // @Add custom methods

  fetchBanners = async (params?: any) => {
    const category = this.props.category || 'guest';

    let httpParams: any = {
      pageNumber: 1,
      nPerPage: 7,
      isActive: true,
      filterByDate: true,
      locations: [category]
    }

    let banners: Array<any> = []

    const bannersResponse = await this.bannerService.fetchBanners(httpParams)

    if (bannersResponse && bannersResponse.banners) {
      banners = bannersResponse.banners.reduce((accum: any, element: any) => {
        let item = {
          key: element?._id,
          ...element
        }

        accum.push(item)

        return accum
      }, [])
    }

    if (banners.length > 1) {
      this.intervalCarousel = setInterval(() => {
        this.next()
      }, 5000)
    }

    this.setState({
      banners,
    })
  }

  goToIndex = (newIndex: number) => {
    this.setState({ activeIndex: newIndex });
  }

  next = () => {
    let items = this.state.banners;

    const nextIndex =
      this.state.activeIndex === items.length - 1
        ? 0
        : this.state.activeIndex + 1;
    this.setState({ activeIndex: nextIndex });
  }

  render() {
    return(
      <BannerModuleLayout
        banners={this.state.banners}
        activeIndex={this.state.activeIndex}
        goToIndex={this.goToIndex}
      />
    )
  }
}

export default connect(mapStatesToProps)(BannerModule)
